/* eslint-disable */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Package, Pencil, ShoppingBag, Trash2 } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import { goodsApi } from "./api";
import "./GoodsDetail.css";

export default function GoodsDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, isAdmin } = useAuth();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    goodsApi.get(id).then((d) => {
      setItem(d);
      setLoading(false);
    }).catch((e) => {
      setError(e.message || "Could not load listing");
      setLoading(false);
    });
  }, [id]);

  const isSeller = item && user && item.seller && item.seller.id === user.id;
  const canEdit = isSeller || isAdmin;

  const handleMarkSold = async () => {
    if (!window.confirm("Mark this item as sold?")) return;
    setSaving(true);
    try {
      const updated = await goodsApi.markSold(id);
      setItem(updated);
    } catch (e) {
      alert(e.message || "Could not mark as sold");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Delete this listing? This cannot be undone.")) return;
    setSaving(true);
    try {
      await goodsApi.delete(id);
      navigate("/goods");
    } catch (e) {
      alert(e.message || "Could not delete listing");
      setSaving(false);
    }
  };

  if (loading) return <div className="gdd-loading">Loading…</div>;
  if (error) return <div className="gdd-error">{error}</div>;
  if (!item) return null;

  return (
    <div className="gdd-page">
      <div className="gdd-back-bar">
        <button className="gdd-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Back
        </button>
      </div>

      {/* Photos */}
      {item.photos && item.photos.length > 0 ? (
        <div className="gdd-photos">
          {item.photos.map((p) => (
            <img
              key={p.id}
              className="gdd-photo"
              src={goodsApi.photoUrl(item.id, p.id)}
              alt={item.title}
            />
          ))}
        </div>
      ) : (
        <div className="gdd-photo-placeholder">
          <Package size={48} />
        </div>
      )}

      {/* Title & price */}
      <h1 className="gdd-title">{item.title}</h1>
      {item.price != null ? (
        <p className="gdd-price">₹{item.price.toLocaleString("en-IN")}</p>
      ) : (
        <p className="gdd-free">Free</p>
      )}
      {item.status === "sold" && <div className="gdd-sold-badge">SOLD</div>}

      {/* Meta */}
      {(item.category || item.condition) && (
        <p className="gdd-meta">
          {[item.category, item.condition && `Condition: ${item.condition}`]
            .filter(Boolean).join(" · ")}
        </p>
      )}

      {/* Description */}
      {item.description && <p className="gdd-desc">{item.description}</p>}

      {/* Seller */}
      {item.seller && (
        <div className="gdd-seller">
          <p className="gdd-seller-label">Listed by</p>
          <p className="gdd-seller-name">{item.seller.name}</p>
        </div>
      )}

      {/* Actions */}
      <div className="gdd-actions">
        {canEdit && item.status === "active" && (
          <>
            <button
              className="gdd-btn gdd-btn-primary"
              onClick={() => navigate(`/goods/${id}/edit`)}
              disabled={saving}
            >
              <Pencil size={15} /> Edit
            </button>
            <button
              className="gdd-btn gdd-btn-sold"
              onClick={handleMarkSold}
              disabled={saving}
            >
              <ShoppingBag size={15} /> Mark sold
            </button>
          </>
        )}
        {canEdit && (
          <button
            className="gdd-btn gdd-btn-danger"
            onClick={handleDelete}
            disabled={saving}
          >
            <Trash2 size={15} /> Delete
          </button>
        )}
      </div>
    </div>
  );
}
